
import { Component, Vue } from 'vue-property-decorator';
import {
  promotionUnsubscribeApi,
  getNewsTypeWithUnsubscribeApi
} from '@/api/api';
import i18n from '@/lang';
@Component({
  name: 'email',
})
export default class extends Vue {
  created(){
    this.rawEmail = this.getRawQueryParam('email');
    this.fkCompanyId=+this.$route.query.cid;
    this.rawType=+this.$route.query.type;
    this.getType();
  }
  public fkCompanyId:any='';
  // 全部退订
  public allClose:boolean=true;
  // 是否已退订
  public isUnsubscribe:boolean=false;
  // 提示
  public tips:any='';
  // 文案
  public content:any='';
  // 当前邮箱
  public rawEmail:any='';
  // 当前类型
  public rawType:any='';
  // 推广列表
  public typeList:any=[];
  public getRawQueryParam(key:string){
    const search = window.location.search;
    if(!search){
      return '';
    }
    const query = search.slice(1).split('&');
    for(const item of query){
      const [paramKey,...paramValue] = item.split('=');
      if(paramKey === key){
        return paramValue.join('=');
      }
    }
    return '';
  }
  public async getType(){
    await this.getTypeList();
  }
  // 获取列表数据
  public async getTypeList(){
    try{
      const {data}:any=await getNewsTypeWithUnsubscribeApi(this.rawEmail);
      const typeList:any=[];
      let all:any={};
      if(data.code==='1003'&&data.datas&&data.datas.length){
        if(this.fkCompanyId===2){
          data.datas.forEach((item:any,index:number)=>{
            if(item.type===0){// 全部取消
              all=item;
            }
            if(item.fkCompanyId===2&&item.type!==3&&item.type!==29&&item.type!==0){// item.type=3是系统消息/29是yami专属按钮
              typeList.push(item);
            }
          })
          typeList.push(all);
          this.typeList=typeList;
        }else{
          this.typeList=data.datas
        }
        this.checkTypeList();
      }
    }catch(err){
      this.isUnsubscribe=true;
      this.tips=i18n.t('unsubscribeTips');
      this.$message.error(i18n.t('errorEmail') as any);
    }
  }
  public async checkTypeList(){
    const type:any=+this.rawType;
    this.allClose=true;
    for(const item of this.typeList){
      if(!item.unsubscribe){
        this.allClose=false;
      }
      if(item.type===type){
        this.content=item.content;
        this.tips=item.tips;
        this.isUnsubscribe=item.unsubscribe
      }
    }
    // 全部退订
    if(this.allClose){
      this.tips=i18n.t('unsubscribeTips');
    }
  }
  public async out(){
    const email:any=this.rawEmail;
    const type:any=this.rawType;
    if(!email){
      this.$message.info(i18n.t('emailTips') as any);
      return
    }
    this.$confirm(
      i18n.t('unsubscribeConfirm') as any,
      '',
    {
      confirmButtonText: i18n.t('confirm') as any,
      cancelButtonText: i18n.t('cancel') as any,
      type: 'warning',
      customClass:'emailConfirm',
    })
    .then(async () => {
      try{
        const {data}:any=await promotionUnsubscribeApi(email,type);
        if(data.code==='1003'){
          this.$message.success(i18n.t('unsubscribeSuccessful') as any);
          this.getTypeList();
        }else{
          this.$message.error(i18n.t('unsubscribeFailed') as any);
        }
      }catch(err){
        this.$message.error(i18n.t('unsubscribeFailed') as any);
      }
    }).catch(()=>{
      this.$message.info(i18n.t('canceled') as any);
    });
    
  }
}
